import ApiService from "../core/services/api.service";

export default {

  getClient(clientId) {
    return ApiService.get(`admin/v1/users/clients/${clientId}`);
  },

  getMessages(discussionGuid) {
    return ApiService.get(`admin/v1/messages/discussions/${discussionGuid}`);
  },

  sendMessages(obj) {
    return ApiService.post(`admin/v1/messages/send`, obj);
  },
};
